import { render, staticRenderFns } from "./dream.vue?vue&type=template&id=688d2cfa&scoped=true"
import script from "./dream.vue?vue&type=script&lang=js"
export * from "./dream.vue?vue&type=script&lang=js"
import style0 from "../../utils/commen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./dream.vue?vue&type=style&index=1&id=688d2cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d2cfa",
  null
  
)

export default component.exports